import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Body2, Heading6 } from '../Typography';

import styles from './index.module.scss';

export interface BannerStyleDownloadButtonProps {
  backgroundColor?: string;
  textColor?: string;
  imageUrl?: string;
  imageAlt?: string;
  iconRight?: React.ReactNode;
  title: string;
  subtitle?: string;
  subtitleColor?: string;
  className: string;
  error?: boolean;
  onClick: () => void;
}

const BannerStyleDownloadButton: React.FC<BannerStyleDownloadButtonProps> = ({
  iconRight,
  title,
  subtitle,
  backgroundColor,
  textColor,
  imageUrl,
  imageAlt,
  subtitleColor,
  className,
  error,
  onClick,
}) => {
  return (
    <div className={styles.wrapper}>
      <button
        type='button'
        onClick={onClick}
        className={cx(styles.button, className)}
        style={{ background: backgroundColor, color: textColor }}
      >
        <span
          className={cx(styles.content, {
            [styles.contentWithImage]: imageUrl,
          })}
        >
          {imageUrl && (
            <img src={imageUrl} alt={imageAlt} className={styles.image} />
          )}
          <span
            className={cx(styles.textWrapper, {
              [styles.textWrapperWithImage]: imageUrl,
            })}
          >
            <span className={styles.titleAndIconWrapper}>
              <Heading6 className={styles.title}>{title}</Heading6>
              {iconRight && (
                <span className={styles.iconRight}>{iconRight}</span>
              )}
            </span>
            {subtitle && (
              <Body2
                style={{ color: subtitleColor }}
                className={styles.subtitle}
              >
                {subtitle}
              </Body2>
            )}
          </span>
        </span>
      </button>
      {error && (
        <Body2 className={styles.errorText}>
          <FormattedMessage
            id='test-result.try-again-later'
            defaultMessage='Something went wrong, please try again later'
          />
        </Body2>
      )}
    </div>
  );
};

export default BannerStyleDownloadButton;
